<template>
  <div class="Travelitinerary" v-if="dataarr.length">
    <div>
      <p>{{title}}</p>
      <div v-for="(item,index) in dataarr" >
        <div  class="liseassembly" style="width: 100%;">
          <div class="li-list">
            <div class="top">
              <span>{{item.dur}}</span>
              <span>|</span>
              <span>{{item.qh_overtime_days}}天</span>
            </div>
            <div class="startend">
              {{item.qh_start_place}}
              <img :src="require('../../assets/img/approval/jt.png')" >
              {{item.qh_end_place}}
            </div>
            <div class="mag" v-if="item.comments_256">
              <van-icon name="description" />
              <div>
                <p v-for="i in item.comments_256.split('\n')" style="line-height:20px">
                  {{i}}
                </p>
              </div>
            </div>
            <div class="magerr" v-if="item.message">
              <van-icon name="warning" />
              <span>
                {{item.message}}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>
<script>
import Icon from 'vant/es/icon/index.js'
import 'vant/es/icon/style/index'
export default {
  name: 'AxTripList',
  props: {
    // 标题
    title: String,
    dataarr: {
      type: Array,
      default: () => {
        return []
      },
    },
  },
  components: {
    'van-icon': Icon,
  },
};
</script>
<style scoped>
/* 出差行程明细 */
.Travelitinerary {
  padding: 16px 8px;
  padding-top: 0;
  font-size: 14px;
  padding-bottom: 20px;
  box-sizing: border-box;
}

.Travelitinerary>div {
  width: 100%;
  background: #fff;
  padding: 16px;
  border-radius: 10px;
  box-sizing: border-box;
}
.Travelitinerary>div>p{
  font-weight: 500;
  font-size: 14px;
  height: 35px;
  /* border-bottom: 1px dashed #DEE3E9; */
}

.Travelitinerary .liseassembly {
  display: flex;
  border-bottom: 1px dashed #DEE3E9;
  margin-top: 16px;
  padding-bottom: 20px;
}

.setcolor .startend,
.setcolor .li-list {
  color: #DEE3E9;
}

.setcolor1 .startend,
.setcolor1 .li-list {
  color: #DEE3E9;
}
.setcolor1 .li-list .top>span[data-v-7f83be55]:nth-child(3) {
  background: #F7F8F9;
  color: #DEE3E9;
}
.setcolor1 .li-list .top>span:nth-child(4) {
  background: #fff;
  color: #1B2532;;
}
.setcolor1 .li-list .top>span:nth-child(4)>span>span:nth-child(1){
  color: #DEE3E9;
}

.setcolor .li-list .top>span[data-v-7f83be55]:nth-child(3) {
  background: #F7F8F9;
  color: #DEE3E9;
}
.setcolor1 .li-list .mag, .setcolor1 .li-list .magerr{
  color: #DEE3E9;
}

.Travelitinerary>div>div:last-child .liseassembly {
  border-bottom: 0;
  padding-bottom: 0;
}

.liseassembly>div:nth-child(1) img {
  width: 12px;
  margin-top: 5px;
  margin-right: 8px;
  /* height: 12px; */
}

.li-list {
  flex: 3;
  font-size: 14px;
}

.li-list .top>span:nth-child(2) {
  margin: 0 10px;
  color: #DEE3E9;
}

.li-list .top>span:nth-child(3) {
  background: rgba(56, 115, 250, 0.05);
  color: #3873FA;
  width: 48px;
  height: 20px;
  line-height: 20px;
  display: inline-block;
  text-align: center;
  border-radius: 10px;
}

.li-list .top>span:nth-child(4) {

  display: inline-block;
  float: right;

}

.li-list .top>span:nth-child(4) img {
  width: 15px;
  margin-top: 2px;
}

.li-list .top>span:nth-child(4) i {
  margin-top: 5px;
}

.li-list .top>span:nth-child(4) {
  position: relative;
}

.li-list .top>span:nth-child(4)>span {
  width: 117px;
  height: 92px;
  position: absolute;
  top: 24px;
  right: 0px;
  background: #fff;
  padding: 10px;
  box-sizing: border-box;
  border: 5px;
  z-index: 2;
  font-size: 12px;
  box-shadow: 0 0 5px #eee;
}
.li-list .top>span:nth-child(4)>span.setheight{
  height: 50px;
}

.li-list .top>span:nth-child(4)>span span {
  /* line-height: 22px; */
  display:inline-block;
  margin-top: 6px;
}
.li-list .top>span:nth-child(4)>span span:nth-child(2){
  margin-top: 24px;
}
.li-list .top>span:nth-child(4)>span span img{
  float: left;
  margin-right: 8px;
}

.li-list .startend {
  display: flex;
  margin-top: 10px;
}

.liseassembly .li-list .startend img {
  width: 15px;
  height: 5px;
  margin: 8px 10px 0 10px;

}

.li-list .mag {
  font-size: 12px;
  display: flex;
  margin-top: 5px;
  color: #637387;
}

.li-list .mag i,
.li-list .magerr i {
  margin-top: 4px;
  margin-right: 5px;
}

.li-list .magerr {
  font-size: 12px;
  display: flex;
  margin-top: 5px;
  color: #FF4D5C;
}
</style>